import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {TargetGroupsDetailsRoutingModule} from './target-groups-details-routing.module';

import {ModalConfirmationModule} from 'shared/modals/modal-confirmation/modal-confirmation.module';
import {TargetGroupsDetailsRepository} from './repositories/target-groups-details.repository';
import {TargetGroupsDetailsService} from './services/target-groups-details.service';
import {TargetGroupsDetailsComponent} from './target-groups-details.component';

import {DragulaModule} from 'ng2-dragula';

@NgModule({
  imports: [
    CommonModule,
    TargetGroupsDetailsRoutingModule,
    FormsModule,
    ModalConfirmationModule,
    DragulaModule,
  ],
  declarations: [
    TargetGroupsDetailsComponent,
  ],
  providers: [
    TargetGroupsDetailsService,
    TargetGroupsDetailsRepository,
  ],
})

export class TargetGroupsDetailsModule {}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/target-groups-details/target-groups-details.module.ts